import { useFreemiumTreatment } from '@hungryroot/experiments';
import { useFreemiumAudience } from '@hungryroot/rest-hooks';

/** Replaces "Added to My Saves" for a freemium treatment guest. */
export const ADDED_TO_COOKBOOKS_COPY = 'Added to Cookbooks';

/** Replaces "Removed from My Saves" for a freemium treatment guest. */
export const REMOVED_FROM_COOKBOOKS_COPY = 'Removed from Cookbooks';

/**
 * Guests in a freemium treatment (Exp 255 or Exp 260) rename the
 * default-cookbook toast. The treatment is read as a peek (`enroll: false`) so
 * showing a toast never enrolls the visitor.
 */
export function useRenameMySavesToast(): boolean {
  const freemium = useFreemiumTreatment({ enroll: false });
  const { audience, isLoading } = useFreemiumAudience();
  return !isLoading && freemium.isTreatment && audience === 'guest';
}

/**
 * Swaps the default-cookbook toast for the Cookbooks sentences for a freemium
 * guest. Explicit `copy` (callers that already named the toast) passes through.
 * Named cookbooks without `copy` also rename — guests only ever heart into the
 * default cookbook on this path, and the product copy is "Cookbooks" rather than
 * the personal default name.
 */
export function mySavesToastProps({
  renameMySaves,
  isInCookbook,
  cookbookName,
  copy,
}: {
  renameMySaves: boolean;
  isInCookbook: boolean;
  cookbookName?: string;
  copy?: string;
}): { cookbookName?: string; copy?: string } {
  if (renameMySaves && copy == null) {
    return {
      copy: isInCookbook
        ? ADDED_TO_COOKBOOKS_COPY
        : REMOVED_FROM_COOKBOOKS_COPY,
    };
  }

  return { cookbookName, copy };
}
